import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownTypeChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import {
  fieldNames,
  changeModalWithInfoBodyStyle,
} from '../../../common/config';
import NotificationSendingAlert, {
  notificationSendingAlertMsgTypes,
} from '../../../../../shared/ui/NotificationSendingAlert/NotificationSendingAlert';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownTypeChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = { value: formValues[fieldNames.type] };
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownType}
      onCancel={close}
      onOk={handleSubmit}
      title={`${shutdown.alertType ? 'Изменить' : 'Добавить'} тип`}
      destroyOnClose
      confirmLoading={loading}
      bodyStyle={changeModalWithInfoBodyStyle}
    >
      <NotificationSendingAlert
        messageType={notificationSendingAlertMsgTypes.cityServices}
      />
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.type}
          form={form}
          initialValue={shutdown.alertType?.id}
          editMode
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_type' })(
  ModalContainer
);

export default ChangeModal;
